// src/pages/msp-inventory/components/reports/DateRangePicker.jsx
import React, { useState } from "react";
import { Calendar } from "lucide-react";

const QUICK_RANGES = [
    { id: "7d", label: "7 Days" },
    { id: "30d", label: "30 Days" },
    { id: "90d", label: "90 Days" },
    { id: "6m", label: "6 Months" },
    { id: "12m", label: "12 Months" },
    { id: "ytd", label: "YTD" },
];

const DateRangePicker = ({ range, setRange }) => {
    const [customOpen, setCustomOpen] = useState(false);
    const [customStart, setCustomStart] = useState("");
    const [customEnd, setCustomEnd] = useState("");

    const applyCustom = () => {
        if (!customStart || !customEnd) return;
        setRange({ key: "custom", start: customStart, end: customEnd });
        setCustomOpen(false);
    };

    return (
        <div className="flex items-center gap-2 flex-wrap">
            {QUICK_RANGES.map((r) => (
                <button
                    key={r.id}
                    onClick={() => setRange({ key: r.id })}
                    className={`px-3 py-1.5 text-xs font-bold rounded-lg border-2 transition ${range.key === r.id ? "border-teal-500 bg-teal-50 text-teal-700" : "border-gray-200 text-gray-500 hover:border-gray-300"}`}
                >
                    {r.label}
                </button>
            ))}
            <div className="relative">
                <button
                    onClick={() => setCustomOpen((o) => !o)}
                    className={`px-3 py-1.5 text-xs font-bold rounded-lg border-2 transition flex items-center gap-1.5 ${range.key === "custom" ? "border-teal-500 bg-teal-50 text-teal-700" : "border-gray-200 text-gray-500 hover:border-gray-300"}`}
                >
                    <Calendar size={12} />
                    {range.key === "custom" ? `${range.start} → ${range.end}` : "Custom"}
                </button>
                {customOpen && (
                    <div className="absolute z-20 top-full left-0 mt-2 bg-white border border-gray-200 rounded-xl shadow-lg p-3 flex items-center gap-2">
                        <input type="date" value={customStart} onChange={(e) => setCustomStart(e.target.value)}
                            className="border border-gray-200 rounded-lg px-2 py-1.5 text-xs focus:outline-none focus:border-teal-500" />
                        <span className="text-gray-400 text-xs">to</span>
                        <input type="date" value={customEnd} onChange={(e) => setCustomEnd(e.target.value)}
                            className="border border-gray-200 rounded-lg px-2 py-1.5 text-xs focus:outline-none focus:border-teal-500" />
                        <button onClick={applyCustom} className="px-3 py-1.5 bg-teal-600 text-white rounded-lg text-xs font-bold hover:bg-teal-700">
                            Apply
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

// Converts a range object into the querystring params every report endpoint expects.
export const rangeToParams = (range) => {
    if (range.key === "custom") return { range: "custom", start: range.start, end: range.end };
    return { range: range.key };
};

export default DateRangePicker;